import api from "@/api/warehouseReceipt";
import customerApi from "@/api/customer";

const CUSTOMER_PAGE_SIZE = 100;
const SEARCH_ERROR = "货主搜索失败，请重试";

export async function searchCustomers(keyword) {
  const name = (keyword || "").trim();
  const customers = [];
  let pageIndex = 1;
  let totalCount;
  do {
    const res = await customerApi.pageQuery({
      request: { pageIndex, pageSize: CUSTOMER_PAGE_SIZE, name }
    });
    const page = res && res.page;
    if (
      !page ||
      !Array.isArray(res.items) ||
      page.pageIndex !== pageIndex ||
      !Number.isInteger(page.totalCount) ||
      page.totalCount < 0
    ) {
      throw new Error("货主分页数据异常");
    }
    customers.push(...res.items);
    totalCount = page.totalCount;
    if (res.items.length === 0 && customers.length < totalCount) {
      throw new Error("货主列表未加载完整");
    }
    pageIndex += 1;
  } while (customers.length < totalCount);
  return customers;
}

/** 保留当前已选货主，避免搜索结果不含该货主时下拉框只显示货主 ID。 */
export function keepSelected(options, previous, selectedId) {
  if (!selectedId || options.some(c => c.customerId === selectedId)) {
    return options;
  }
  const selected = previous.find(c => c.customerId === selectedId);
  return selected ? [selected].concat(options) : options;
}

export default {
  data() {
    return {
      ownerReady: false,
      ownerError: "",
      boundCustomerId: "",
      customers: [],
      customerLoading: false,
      customerSearchId: 0
    };
  },
  methods: {
    async initOwner() {
      this.ownerReady = false;
      this.ownerError = "";
      try {
        const user = await api.currentUser();
        if (!user || typeof user !== "object")
          throw new Error("用户信息加载失败");
        this.boundCustomerId = user.customerId || "";
        if (this.boundCustomerId) {
          this.customers = [
            { customerId: this.boundCustomerId, name: this.boundCustomerId }
          ];
        } else {
          this.customers = await searchCustomers("");
        }
        this.ownerReady = true;
        return true;
      } catch (error) {
        this.ownerError = "货主信息加载失败，请刷新重试";
        return false;
      }
    },
    async searchOwners(keyword, selectedId) {
      if (this.boundCustomerId) return;
      const id = ++this.customerSearchId;
      this.customerLoading = true;
      try {
        const options = await searchCustomers(keyword);
        if (id === this.customerSearchId) {
          this.customers = keepSelected(options, this.customers, selectedId);
          if (this.ownerError === SEARCH_ERROR) this.ownerError = "";
        }
      } catch (error) {
        if (id === this.customerSearchId) this.ownerError = SEARCH_ERROR;
      } finally {
        if (id === this.customerSearchId) this.customerLoading = false;
      }
    }
  }
};
